module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/logo_y-7072b806ba132bc54455ee9324d798da.png";